import { useMemo } from 'react';
import { Link, type LinkProps, type To, useLocation } from 'react-router';

export function LinkWithSrc({ to, ...props }: LinkProps) {
  const location = useLocation();

  const nextTo: To = useMemo(() => {
    const backLink = location.pathname + location.search;
    let pathname: string;
    let searchParams: URLSearchParams;

    if (typeof to === 'string') {
      pathname = to;
      searchParams = new URLSearchParams();
    } else {
      pathname = to.pathname ?? '/';
      searchParams = new URLSearchParams(to.search);
    }

    searchParams.set('src', backLink);
    const search = searchParams.toString();

    return { pathname, search };
  }, [location, to]);

  return <Link to={nextTo} {...props} />;
}
